import Vue from 'vue'

export default {
	data() {
		return {
			viewPadding: {
				top: 0,
				bottom: 0
			}
		}
	},
	computed: {
		viewStyles() { //add this prop as style attr to your $el element (:style="viewStyles")
			return {
				"padding-top": this.viewPadding.top + "px",
				"padding-bottom": this.viewPadding.bottom + "px"
			}
		}
	},
	methods: {
		setTopPadding(value) {
			Vue.set(this.viewPadding, 'top', value)
		},
		setBottomPadding(value) {
			Vue.set(this.viewPadding, 'bottom', value)
		}
	}
}
